<template src="./userProfilePage.html"></template>

<script>
    import usersEndpoints from '../users.endpoints.js';

    export default {
        name: 'user-profile-page',
        data() {
            return {
                dto: {}
            }
        },
        watch: {
            signedInUser: {
                handler(newVal) {
                    if (newVal) {
                        this.getProfile();
                    }
                }
            }
        },
        computed: {
            signedInUser() {
                return this.$store.state.PermissionsModule.signedInUser || {};
            }
        },
        methods: {
           changePassword() {
                DMUtils.openApplicationModal('usersChangePasswordModal', { callback: this.getProfile });
           },
           getProfile() {
                usersEndpoints.getProfile(this.signedInUser.UserID)
                    .then((response) => {
                        this.dto = response;
                    })
           },
           btnSaveOnClick() {
                usersEndpoints.updateProfile(this.dto)
                    .then(() => {
                        this.getProfile();
                    })
           }
        },
        created() {
            if (this.signedInUser.UserID) {
                this.getProfile();
            }
        }
    }
</script>
